import { render } from "./FileItemComponent.vue?vue&type=template&id=4db31509&scoped=true"
import script from "./FileItemComponent.vue?vue&type=script&lang=js"
export * from "./FileItemComponent.vue?vue&type=script&lang=js"

import "./FileItemComponent.vue?vue&type=style&index=0&id=4db31509&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db31509"]])

export default __exports__